export class ResponseEnvelope{
    private header: ResponseEnvelopeHeader;
    private body: any;

    constructor(responseJson: any){
        if(responseJson ){
            this.header = new ResponseEnvelopeHeader(responseJson.header);
            this.body = responseJson.body;
        }else{
            console.error("Couldn't read response json. "+responseJson);
        }
    }

    /**
     * name
     */
    public getBody(): any {
        return this.body;
    }

    public setBody(bodyObj: any): void {
        this.body = bodyObj;
    }

    public getHeader():ResponseEnvelopeHeader{
        return this.header;
    }

    public setHeader(header: ResponseEnvelopeHeader){
        this.header = header;
    }

}


export class ResponseEnvelopeHeader {
    private statusCode: string;
    private statusMsg: string;

    constructor(respJsonHeader: any){
        if(respJsonHeader){
            this.statusCode = respJsonHeader.statusCode;
            this.statusMsg = respJsonHeader.statusMsg;
        }else{
            console.error("Couldn't read response header json. "+respJsonHeader);            
        }
    }

    public setStatusMsg(msg: string): void {
        this.statusMsg = msg;
    }

    public getStatusMsg(): string {
        return this.statusMsg;
    }

    public setStatusCode(statusCode: string): void {
        this.statusCode = statusCode;
    }

    public getStatusCode(): string {
        return this.statusCode;
    }

}

// export class ErrorResponse implements Error{
//     private statusCode: String;
//     private statusMsg: String;
//     private _message: string = null;
//     private  _httpStatusCode: number;

//     constructor(errorJson: any){
//         this.message = "A custom error occurred while calling service";
//         if(errorJson && errorJson.header){
//             this.statusCode = errorJson.header.statusCode;
//             this.statusMsg = errorJson.header.statusMsg;
//         }else{
//             console.error("Failed to read error response. "+errorJson);
//             this.statusCode = "UNEXPECTED_ERROR";
//             this.statusMsg = "An unexpected error returned from server.";
//         }
//     }

//     public get message(): string {
//         return this._message;
//     }
//     public set message(message: string) {
//         this._message = message;
//     }

//     public get httpStatusCode(): number {
//         return this._httpStatusCode;
//     }
//     public set httpStatusCode(httpStatusCode: number) {
//         this._httpStatusCode = httpStatusCode;
//     }

//     public get name(): string {
//         return (<any>this).constructor.name;
//     }

//     public setStatusMsg(msg: String): void {
//         this.statusMsg = msg;
//     }

//     public getStatusMsg(): String {
//         return this.statusMsg;
//     }

//     public setStatusCode(statusCode: String): void {
//         this.statusCode = statusCode;
//     }

//     public getStatusCode(): String {
//         return this.statusCode;
//     }
// }
// // To extend Error 
// (<any>Object).setPrototypeOf(ErrorResponse.prototype, Error.prototype);


// WEBPACK FOOTER //
// ./src/app/http/http.models.ts